import firebase from 'firebase';
import firebaseui from 'firebaseui';

const DEFAULT_CONFIG = {
  firebase: {
    apiKey: 'AIzaSyBhoInwVm-B_-XwT2R6AjIgDH6N-7ZvnIM',
    authDomain: 'nightingale-512.firebaseapp.com',
    databaseURL: 'https://nightingale-512.firebaseio.com',
    projectId: 'nightingale-512',
    storageBucket: 'nightingale-512.appspot.com',
    messagingSenderId: '1080164938217',
  },
  firebaseui: {
    signInFlow: 'popup',
    signInOptions: [
      // Leave the lines as is for the providers you want to offer your users.
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    ],
    // Terms of service url.
    tosUrl: '/',
    callbacks: {
      signInSuccess: () => false,
    },
  },
};

export default class FirebaseService {
  constructor(config = DEFAULT_CONFIG) {
    // todo load from settings
    this._config = config.firebase;
    firebase.initializeApp(this._config);

    this._uiConfig = config.firebaseui;
    this._authUi = new firebaseui.auth.AuthUI(firebase.auth());
  }

  startFirebaseUI = cssSelector => this._authUi.start(cssSelector, this._uiConfig);
  resetFirebaseUI = () => this._authUi.reset();
}



// WEBPACK FOOTER //
// ./src/services/FirebaseService.js